import { Box, Button, Typography } from '@mui/material';
import React, { FC, useEffect, useState } from 'react';
import CreateForm from '../../../../../components/ui-component/form-component/create-form/CreateForm';
import { cloneDeep } from 'lodash';
import { set } from 'lodash';
import { useAuthentication } from '../../../../../context/AuthContext';
import GetRecord from '../../../../../lib/api/GetRecord';
import { APIS } from '../../../../../lib/constants/apis';
import { get } from 'lodash';
import { removeDataKeys, removeNullDeep } from '../../../../../utils/helper';
import PersonalDataValidator from './PersonalDataValidator';
import PutRecord from '../../../../../lib/api/PutRecord';
import MuiSnackbar from '../../../../../components/ui-component/mui-snackbar/MuiSnackbar';
import { NOT_FOUND_ERROR_MESSAGE } from '../../../../../lib/constants/constant';
import LoadingIconOnly from '../../../../../components/ui-component/loading/LoadingIconOnly';

import Schema from '../../../../../lib/paths/person_FULL_Paths.json';
const P = Schema.attributes;

const formStruc = [
	{ fields: [P.Personenbezogene_Daten_Anrede] },
	{ fields: [P.Personenbezogene_Daten_Titel] },
	{ fields: [P.Personenbezogene_Daten_Vorname, P.Personenbezogene_Daten_Nachname] },
	{ fields: [P.Kontaktdaten_E_Mail, P.Kontaktdaten_Telefon] },
];

const PersonalData: FC<{}> = () => {
	const { authenticatedData } = useAuthentication();
	const [loading, setLoading] = useState<boolean>(true);
	const [updateSuccess, setUpdateSuccess] = useState<boolean | null>(null);
	const [wsError, setWsError] = useState<boolean>(false);
	const [personData, setPersonData] = useState<Record<string, any>>({});
	const [formErrors, setFormErrors] = useState<Record<string, any>>({});

	const handleInputChange = (path: string, value: any) => {
		setUpdateSuccess(null);
		let personDataCopy = cloneDeep(personData);
		set(personDataCopy, path, value);
		setPersonData(personDataCopy);
	};
	const validatePersonData = () => {
		let errorObject = {};
		let errs = PersonalDataValidator.validate(personData);
		for (let error of errs) {
			set(errorObject, error.path, get(error, 'message'));
		}
		setFormErrors(errorObject);
		return Object.keys(errorObject).length === 0;
	};
	const handleUpdatePersonData = async () => {
		if (validatePersonData()) {
			let res = await PutRecord(APIS.Person, get(authenticatedData, 'personId'), { data: get(personData, 'attributes') });
			if (get(res, 'data.id')) setUpdateSuccess(true);
		}
	};

	useEffect(() => {
		const fetchPerson = async () => {
			setLoading(true);
			try {
				let res = await GetRecord(APIS.Person, get(authenticatedData, 'personId'));
				setPersonData(removeNullDeep(removeDataKeys(get(res, 'data', {}))));
			} catch (err) {
				console.error('ERROR Fetching Person ', err);
				setWsError(true);
			} finally {
				setLoading(false);
			}
		};
		fetchPerson();
	}, [authenticatedData]);

	if (loading) return <LoadingIconOnly />;
	return (
		<>
			<MuiSnackbar
				showSnackbar={wsError}
				closeSnackbar={() => setWsError(false)}
				alertMessage={NOT_FOUND_ERROR_MESSAGE}
				error={wsError}
			/>
			<MuiSnackbar
				showSnackbar={updateSuccess}
				closeSnackbar={() => setUpdateSuccess(null)}
				alertMessage="Daten wurde aktualisiert"
			/>
			<Typography variant="h3">Persönliche Daten</Typography>
			<CreateForm
				formStruc={formStruc}
				formValues={personData}
				formErrors={formErrors}
				updateFormValuesFunc={handleInputChange}
			/>

			<Box sx={{ textAlign: 'right', mt: '2rem' }}>
				<Button onClick={handleUpdatePersonData}>Aktualisieren</Button>
			</Box>
		</>
	);
};
export default PersonalData;
